import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { acknowledgeNotification } from '@perpay-web/fintech/actions/entities/notifications';

export const useAcknowledgeNotification = () => {
    const dispatch = useDispatch();

    const acknowledgeNotificationAction = useCallback(
        (uuid) => {
            dispatch(acknowledgeNotification(uuid));
        },
        [dispatch],
    );

    return acknowledgeNotificationAction;
};
